export const mensajesInbox = {
  title: "Messages",

  noAccess: {
    description:
      "To access the message inbox you must have your own WhatsApp Business number connected from your account settings.",
    connectButton: "Connect WhatsApp",
  },

  search: {
    placeholder: "Search by phone or guest...",
  },

  filters: {
    allProperties: "All properties",
    searchProperty: "Search property...",
    filterTitle: "Filter messages",
    clearAll: "Clear filters",
    removeOne: "Remove “{filtro}”",
    someActive: "{count} filters",
  },

  tabs: {
    all: "All",
    unread: "Unread",
    pinned: "Pinned",
    archived: "Archived",
    noReservation: "No booking",
    otaBooking: "Booking.com",
    otaAirbnb: "Airbnb",
    otaExpedia: "Expedia",
    otaOther: "Other OTA",
    unpaid: "Unpaid",
    paid: "Paid",
    arrivingSoon: "Arriving soon",
  },

  filterGroups: {
    chat: "Conversation",
    origin: "Source",
    reservation: "Booking",
  },

  list: {
    empty: "No conversations",
    noMessages: "No messages",
  },

  channels: {
    web: "Web",
    webConcierge: "Web concierge · Stay portal",
    otaMessage: "{provider} message",
  },

  chat: {
    placeholderSelect: "Select a conversation to get started",
    loading: "Loading conversation...",
    dropToAttach: "Drop here to attach files",
    emptyThread: "No messages yet in this thread",
    notSent: "Not sent",
    sending: "Sending...",
  },

  sender: {
    guest: "Guest",
    you: "You",
    aiAgent: "AI Agent",
  },

  media: {
    document: "Document",
    sharedLocation: "Shared location",
    attachment: "Attachment",
  },

  preview: {
    attachmentSent: "Attachment sent",
    messageSent: "Message sent",
    attachmentReceived: "Attachment received",
    newMessage: "New message",
  },

  mode: {
    aiAgent: "AI Agent",
    manual: "Manual",
  },

  automation: {
    disabledNotice:
      "The AI Agent is not enabled for this property: it won't reply, you write the messages.",
    aiActiveBanner:
      "The AI agent is replying to this guest automatically.",
  },

  faq: {
    title: "Frequently asked questions",
  },

  composer: {
    placeholder: "Type a message or use / to insert a reply...",
    hint: "Enter to send · Shift+Enter for a new line",
  },

  actions: {
    newConversation: "New conversation",
    options: "Options",
    attachFile: "Attach file",
  },

  alt: {
    flag: "Flag",
    sentImage: "Sent image",
  },

  common: {
    file: "file",
    notAvailable: "Not available",
  },

  nights: "{count} night | {count} nights",

  arrival: {
    pending: "Date pending",
    today: "Arrives today",
    tomorrow: "Arrives tomorrow",
    yesterday: "Arrived yesterday",
    inDays: "In {count} days",
    daysAgo: "Arrived {count} days ago",
  },

  reservationStatus: {
    booked: "Confirmed",
    cancelled: "Cancelled",
    pending: "Pending",
    checked_in: "Checked in",
    checked_out: "Checked out",
  },

  reservationPanel: {
    title: "Linked booking",
    stayEnded: "The guest is no longer staying",
    checkIn: "Check-in",
    checkOut: "Check-out",
    room: "Room",
    reservation: "Booking",
    phone: "Phone",
    viewReservation: "View booking",
    noReservationTitle: "No linked booking",
    noReservationOta:
      "This thread came from {channel} via Channex and isn't linked to a local booking yet.",
    noReservationWhatsapp:
      "This contact wrote to the connected WhatsApp but isn't linked to a booking yet.",
    assignReservation: "Assign booking",
    createReservation: "Create booking",
    assignExisting: "Assign existing booking",
    searchPlaceholder: "Search by name or code...",
    noReservationsFound: "No bookings found",
    placeholderContext: "Select a conversation to see the context",
    propertyUnavailable: "Property unavailable",
  },

  contextMenu: {
    pin: "Pin conversation",
    unpin: "Unpin conversation",
    archive: "Archive conversation",
    unarchive: "Unarchive conversation",
  },

  waStatus: {
    read: "Read",
    delivered: "Delivered",
    queued: "Queued",
    failed: "Failed",
    sent: "Sent",
  },

  waFailTitle: {
    noWhatsapp: "No WhatsApp",
    invalidNumber: "Invalid number",
    notSent: "Not sent",
  },

  waErrors: {
    generic: "This message couldn't be sent via WhatsApp.",
  },

  waErrorShort: {
    e131042: "payment issue on the WhatsApp account",
    e131026: "the number can't receive WhatsApp",
    e131053: "WhatsApp couldn't download the file",
    e132000: "missing data in the template",
    e131009: "the message doesn't meet WhatsApp's requirements",
  },

  toasts: {
    aiActiveSwitchManual:
      "The AI agent is active. Switch to manual mode to reply.",
    pinned: "Conversation pinned",
    unpinned: "Conversation unpinned",
    archived: "Conversation archived",
    unarchived: "Conversation unarchived",
    reservationAssigned: "Booking assigned: {name}",
    reservationUnassigned: "Booking unassigned",
    selectPropertyToCreate:
      "Select a property to create the booking from this chat.",
    userNotResolved: "Could not resolve the panel user.",
    aiNotEnabledConfig:
      "This property doesn't have the AI Agent enabled. Enable it from the listing settings.",
    aiEnabledForChat: "AI Agent enabled for this conversation",
    manualEnabledForChat: "Manual mode enabled for this conversation",
    templateSent: "Template sent successfully.",
  },

  errors: {
    inboxNotActive:
      "The message inbox isn't active for this account, or the business WhatsApp still needs to be connected.",
    openConversation: "Couldn't open the conversation",
    sendMessage: "Couldn't send the message. Check your WhatsApp connection.",
    pin: "Error pinning conversation",
    archive: "Error archiving",
    loadReservations: "Error loading bookings",
    assignReservation: "Error assigning the booking",
    unassignReservation: "Error unassigning the booking",
    updateMode: "Couldn't update the mode for this conversation",
    reactivationTemplate: "Couldn't send the reactivation template.",
  },
};
